import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { RichTextOutput } from 'libs/end-to-end/src/custom-viz/RichTextTypes';

export const RichTextCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'richText',
  isDataQueuingAllowed: false,
  outputFileName: 'rich_text_output.json',
  outputSchema: RichTextOutput,
  resolveFocusArea: () => null,
  resolveFilters: () => null,
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => ({
    'Custom Viz Type': request.customVizId,
    'Selected Dimensions': [],
    'Selected Metrics': [],
    'Selected Focus Areas': [],
    Filters: [],
  }),
  getUrlPath: () => null,
};
